__webpack_require__.p = "https://try-er.github.io/debasish/";